<div class="change-password-page">
  <header class="change-password-header">
    <div class="header-toolbar">
      <button class="back-button" (click)="goBack()">
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="page-title">Change Password</h1>
    </div>
  </header>

<div class="change-password-card">
     <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="form-group">
      <label>Current Password</label>
      <input type="password" formControlName="old_password" placeholder="Enter current password" />
      <div class="error" *ngIf="isSubmitted && errorControl.old_password.errors">
        Current password is required.
      </div>
    </div>

    <div class="form-group">
      <label>New Password</label>
      <input type="password" formControlName="password" placeholder="Enter new password" />
      <div class="error" *ngIf="isSubmitted && errorControl.password.errors">
        <span *ngIf="errorControl.password.errors.required">New password is required.</span>
        <span *ngIf="errorControl.password.errors.minlength">Minimum 6 characters required.</span>
      </div>
    </div>

    <div class="form-group">
      <label>Confirm New Password</label>
      <input type="password" formControlName="confirm_password" placeholder="Confirm new password" />
      <div class="error" *ngIf="isSubmitted && (errorControl.confirm_password.errors || changePasswordForm.errors?.mismatch)">
        <span *ngIf="errorControl.confirm_password.errors">Confirmation is required.</span>
        <span *ngIf="changePasswordForm.errors?.mismatch">Passwords do not match.</span>
      </div>
    </div>

    <button type="submit" [disabled]="isLoading">
      {{ isLoading ? 'Updating...' : 'Update Password' }}
    </button>
  </form>
</div>

</div>
